import Box from '@mui/material/Box';
import { useContext } from 'react';

import useHover from '@hooks/useHover';
import Fade from '@mui/material/Fade';
import { SessionContext } from '@Provider/index';

import Stack from '@mui/material/Stack';
import { AvatarStyled, BoxMessage, StackLoading } from './styles';

const ChatLoading = () => {
  const { sdk } = useContext(SessionContext);
  const [ref]: any = useHover<any>();

  return (
    <Stack
      ref={ref}
      width="30%"
      direction="row"
      alignItems="flex-start"
      spacing={1}
      padding="8px 0px"
    >
      <AvatarStyled src={sdk.avatar} />

      <Fade in timeout={400}>
        <BoxMessage
          bgcolor={sdk.receiverChat || 'background.paper'}
          color={theme =>
            sdk.receiverTextColor ||
            (theme.palette.mode === 'dark' ? '#000' : '#FFF')
          }
        >
          <StackLoading
            direction="row"
            spacing={0.8}
            justifyContent="center"
            alignItems="center"
            margin="4px 6px"
          >
            <Box className="dot" key="box1" />
            <Box className="dot" key="box2" />
            <Box className="dot" key="box3" />
          </StackLoading>
        </BoxMessage>
      </Fade>
    </Stack>
  );
};

export default ChatLoading;
